// Playwright tests do not compile if an object like this is exported from the same file as the component.
// moving to a separate file to avoid this for now. Review later.

export const TEST_IDS = {
  DIALOG: 'modal-dialog',
};
